module.exports = __webpack_public_path__ + "img/5.f3a490c9.jpg";